import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/sections/Navbar";
import Hero from "./components/sections/Hero";
import Features from "./components/sections/Features";
import About from "./components/sections/About";
import Catalog from "./components/sections/Catalog";
import ComoFunciona from "./components/sections/ComoFunciona";
import Galeria from "./components/sections/Galeria";
import FAQ from "./components/sections/FAQ";
import Contato from "./components/sections/Contato";
import WhatsAppButton from "./components/sections/WhatsAppButton";
import { Toaster } from "./components/ui/toaster";

const Landing = () => {
  return (
    <div className="bg-[#09080d] min-h-screen overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <Features />
        <Catalog />
        <ComoFunciona />
        <About />
        <Galeria />
        <FAQ />
        <Contato />
      </main>
      <WhatsAppButton />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
